import { MessageAction } from '@crowdex/ui/ai/message';
import { Check, Copy } from 'lucide-react';
import { useCopyToClipboard } from '@/hooks/use-copy-to-clipboard';

/**
 * The icon buttons under a message (copy, read aloud, side chat, rewind): 28 px with a pointer,
 * a finger's 44 px on a touch screen (the icon keeps its size).
 */
export const MESSAGE_ACTION =
  'size-7 pointer-coarse:size-11 text-muted-foreground hover:text-foreground';

/**
 * The room a message keeps under it for its actions' row (`absolute top-full mt-1`): a finger's
 * 44 px row reaches past the gap to the next message, which would cover its targets' lower half.
 */
export const MESSAGE_ACTIONS_ROOM = 'pointer-coarse:mb-7';

export function MessageCopyAction({ text }: { text: string }) {
  const { copied, copy } = useCopyToClipboard();

  return (
    <MessageAction
      aria-label={copied ? 'Copied' : 'Copy message'}
      className={MESSAGE_ACTION}
      onClick={(event) => {
        event.stopPropagation();
        void copy(text);
      }}
      tooltip={copied ? 'Copied' : 'Copy message'}
    >
      {copied ? <Check className="size-3.5" /> : <Copy className="size-3.5" />}
    </MessageAction>
  );
}
